import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

// Utils
import cn from '../../utils/cn';

import style from './IconAction.module.css';

const IconAction = ({
  className, onClick, icon, color, isActive, activeIcon, activeColor,
}) => {
  const btnRef = useRef(null);
  const icoRef = useRef(null);

  useEffect(() => {
    if (color && icoRef.current && !isActive) icoRef.current.style.color = color;
    if (icoRef.current && activeColor && isActive) icoRef.current.style.color = activeColor;
  }, [color, icoRef, activeColor, isActive]);

  const handleMouseEnter = () => {
    // If activeIcon defined and not active then should display it with animation
    if (activeIcon && icoRef.current && !isActive) {
      icoRef.current.className = `${activeIcon} ${style.animFade}`;
      icoRef.current.style.color = activeColor;
    }
  };

  const handleMouseLeave = () => {
    // Go back to default icon if not active
    if (activeIcon && icoRef.current && !isActive) {
      icoRef.current.className = icon;
      icoRef.current.style.color = color;
    }
  };

  const handleOnClick = () => {
    // Trigger click param and animation
    onClick();

    if (icoRef.current) {
      setTimeout(() => {
        icoRef.current.classList.add(style.animClick);
      }, 0);
    }
    setTimeout(() => {
      icoRef.current.classList.remove(style.animClick);
    }, 300);
  };

  return (
    <button
      ref={btnRef}
      className={cn([style.iconAction, className])}
      type="button"
      onClick={handleOnClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <i
        ref={icoRef}
        className={cn([(isActive && activeIcon) ? activeIcon : icon])}
      />
    </button>
  );
};

IconAction.propTypes = {
  onClick: PropTypes.func.isRequired,
  icon: PropTypes.string.isRequired,
  color: PropTypes.string,
  isActive: PropTypes.bool,
  activeIcon: PropTypes.string,
  activeColor: PropTypes.string,
  className: PropTypes.string,
};

IconAction.defaultProps = {
  color: null,
  isActive: false,
  activeIcon: null,
  activeColor: null,
  className: null,
};

export default IconAction;
